import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";

// Public pages
import Home from "@/pages/Home";
import Rates from "@/pages/Rates";
import Submit from "@/pages/Submit";
import Submitted from "@/pages/Submitted";
import Track from "@/pages/Track";
import Signin from "@/pages/Signin";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Refer from "@/pages/Refer";
import Pricing from "@/pages/Pricing";
import HowItWorks from "@/pages/HowItWorks";
import AcceptedCards from "@/pages/AcceptedCards";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import { Blog, BlogPost } from "@/pages/Blog";
import Category from "@/pages/Category";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

// Admin pages
import AdminGate from "@/components/admin/AdminGate";
import AdminLogin from "@/admin/AdminLogin";
import AdminOverview from "@/admin/AdminOverview";
import AdminAnalytics from "@/admin/AdminAnalytics";
import AdminSubmissions from "@/admin/AdminSubmissions";
import AdminSubmissionDetail from "@/admin/AdminSubmissionDetail";
import AdminUsers from "@/admin/AdminUsers";
import AdminPayouts from "@/admin/AdminPayouts";
import AdminLiveChat from "@/admin/AdminLiveChat";
import AdminAiTranscripts from "@/admin/AdminAiTranscripts";
import AdminNotifications from "@/admin/AdminNotifications";
import AdminKnowledgeBase from "@/admin/AdminKnowledgeBase";
import AdminBlogManager from "@/admin/AdminBlogManager";
import AdminSupportInbox from "@/admin/AdminSupportInbox";
import AdminVendors from "@/admin/AdminVendors";
import AdminAuditLog from "@/admin/AdminAuditLog";
import AdminSettings from "@/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Home />} />
            <Route path="/rates" element={<Rates />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/submitted" element={<Submitted />} />
            <Route path="/track" element={<Track />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/refer" element={<Refer />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/accepted-cards" element={<AcceptedCards />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/sell/:brand" element={<Category />} />
            <Route path="/legal/terms" element={<Legal slug="terms" />} />
            <Route path="/legal/privacy" element={<Legal slug="privacy" />} />
            <Route path="/legal/cookies" element={<Legal slug="cookies" />} />
            <Route path="/legal/refund" element={<Legal slug="refund" />} />
            <Route path="/legal/acceptable" element={<Legal slug="acceptable" />} />

            {/* Admin */}
            <Route path="/admin" element={<Navigate to="/admin/submissions" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/overview" element={<AdminGate><AdminOverview /></AdminGate>} />
            <Route path="/admin/analytics" element={<AdminGate><AdminAnalytics /></AdminGate>} />
            <Route path="/admin/submissions" element={<AdminGate><AdminSubmissions /></AdminGate>} />
            <Route path="/admin/submissions/:id" element={<AdminGate><AdminSubmissionDetail /></AdminGate>} />
            <Route path="/admin/users" element={<AdminGate><AdminUsers /></AdminGate>} />
            <Route path="/admin/payouts" element={<AdminGate><AdminPayouts /></AdminGate>} />
            <Route path="/admin/live-chat" element={<AdminGate><AdminLiveChat /></AdminGate>} />
            <Route path="/admin/ai-transcripts" element={<AdminGate><AdminAiTranscripts /></AdminGate>} />
            <Route path="/admin/notifications" element={<AdminGate><AdminNotifications /></AdminGate>} />
            <Route path="/admin/knowledge-base" element={<AdminGate><AdminKnowledgeBase /></AdminGate>} />
            <Route path="/admin/blog" element={<AdminGate><AdminBlogManager /></AdminGate>} />
            <Route path="/admin/support-inbox" element={<AdminGate><AdminSupportInbox /></AdminGate>} />
            <Route path="/admin/vendors" element={<AdminGate><AdminVendors /></AdminGate>} />
            <Route path="/admin/audit-log" element={<AdminGate><AdminAuditLog /></AdminGate>} />
            <Route path="/admin/settings" element={<AdminGate><AdminSettings /></AdminGate>} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
